export class Country {
  static UnitedStates = "us";
  static Canada = "can";
}